import React from 'react';
import Page from '../../../lib/page';
import { Rec } from '../../../component';
import { Pagination, LocaleProvider } from 'antd';
import { Row, Input, Button } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import styles from './index.css';
import { connect } from 'dva';
import Tag from './tag';

class CategoryPage extends Page {

    state = {
        value: this.props.search.query,
    }
    changeHandler(e) {
        this.setState({
            value: e.target.value
        })
    }

    change_page = page => {
        this.props.dispatch({
            type: 'search/change_page',
            payload: { page },
        });
    }

    componentDidMount() {
        if (this.props.search.books.length === 0) {
            this.props.dispatch({
                type: 'search/do_search',
            });
        }
        // this.props.dispatch({
        //     type: 'search/do_search',
        // });
    }

    render() {
        return (
            <div className={styles.category_wrap}>
                {/*筛选条件*/}
                <ul className={styles.filter_content}>
                    {this.props.search.filter.map((val, idx) => (
                        <li key={idx}>
                            <span className={styles.filter_title}>{val.name}：</span>
                            <div className={styles.filter_condition}>
                                {val.options.map((item, index) => (
                                    <Tag key={index} tag={val.key} data={item} />
                                ))}
                            </div>
                        </li>
                    ))}
                    <li style={{ margin: '10px 0 10px 90px', textAlign: 'left' }}>
                        <Input.Search
                            placeholder="请输入、书名、作者进行查询"
                            enterButton="搜索"
                            value={this.state.value}
                            onChange={this.changeHandler.bind(this)}
                            onSearch={value => this.props.dispatch({
                                type: 'search/query',
                                payload: value,
                            })}
                            style={{
                                width: '452px',
                            }}
                        />
                    </li>
                </ul>
                <Rec.ListRec
                    template='brief_3_big'
                    column={2}
                    width={480}
                    gap={30}
                    data={this.props.search.books.map((book) => ({
                        id: book.novel_id,
                        name: book.novel_name,
                        pic: book.pic,
                        cata: book.tag_name,
                        brief: book.summary,
                        is_done: Number(book.is_done) === 1 ? '已完结' : '连载中',
                    }))}
                />

                <div className={styles.pagination}>
                    <LocaleProvider locale={zhCN}>
                        <Pagination
                            showQuickJumper
                            current={this.props.search.page}
                            onChange={this.change_page}
                            pageSize={1}
                            total={this.props.search.total_page}
                        />
                    </LocaleProvider>
                </div>
            </div>
        )
    }
}

const state_props = state => {
    return {
        search: state.search,
    }
}

export default connect(state_props)(CategoryPage);



// WEBPACK FOOTER //
// ./src/layout/book/category/index.js